<template>
  <div>
    <div class="section">
      <div class="container">
        <!-- Funding Loaded -->
        <div v-if="!loading && funding !== null">
          <Breadcrumbs :history="breadcrumbs" current="Funding Details" />
          <!-- Header Loaded -->
          <div class="mb-lg">
            <div class="has-background-white has-shadow pa-md mb-xxs">
              <div class="columns is-vcentered is-mobile">
                <div class="column">
                  <p class="is-size-5 has-text-weight-bold">{{ funding.name }}</p>
                  <p class="has-text-grey has-text-grey-light">
                    {{ funding.client.organization.name }} &bull;
                    {{ funding.client.name }}
                  </p>
                </div>
                <div class="column is-narrow has-text-right">
                  <p class="is-size-5">
                    <StatusPresenter :funding="funding" />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- Layout -->
          <div class="columns">
            <!-- Menu -->
            <div class="column is-narrow">
              <b-menu class="pr-lg">
                <b-menu-list label="Menu">
                  <b-menu-item
                    icon="checkbox-multiple-marked-outline"
                    label="Summary"
                    tag="router-link"
                    :to="{ name: 'network.funding', params: { code: context.code, id: funding.id } }"
                    exact
                  ></b-menu-item>
                  <b-menu-item
                    icon="swap-vertical"
                    label="Revisions"
                    tag="router-link"
                    :to="{ name: 'network.funding.revisions', params: { code: context.code, id: funding.id } }"
                    :disabled="(funding.status !== 'active')"
                  ></b-menu-item>
                  <!-- <b-menu-item
                    icon="swap-horizontal"
                    label="Transfers"
                    tag="router-link"
                    :to="{ name: 'network.funding.transfers', params: { code: context.code, id: funding.id } }"
                    exact
                  ></b-menu-item> -->
                  <b-menu-item
                    icon="pulse"
                    label="Activity"
                    tag="router-link"
                    :to="{ name: 'network.funding.activities', params: { code: context.code, id: funding.id } }"
                    exact
                  ></b-menu-item>
                </b-menu-list>
              </b-menu>
            </div>
            <!-- Content -->
            <div class="column">
              <div>
                <router-view v-if="funding !== null" :funding="funding" @refresh="load(true)"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StatusPresenter from '@/components/Models/Funding/Presenters/Status'

export default {
  components: {
    StatusPresenter
  },
  computed: {
    ...mapGetters(['api', 'context']),
    breadcrumbs () {
      return [{ label: 'Funding', name: 'network.fundings', params: { code: this.context.code } }]
    },
    endpoint () {
      return this.api.route + '/funding/' + this.$route.params.id
    }
  },
  data () {
    return {
      loading: true,
      funding: null,
      showAccessModal: false
    }
  },
  methods: {
    load (refreshOnly) {
      if (!refreshOnly) this.loading = true
      this.$http.get(this.endpoint).then(response => {
        this.funding = response.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mixins: [],
  mounted () {
    this.load()
  }
}
</script>
